import { Component, Prop, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'

import SwitchPortal from '@/components/edit/SwitchPortal/index.vue'
import String from '@/components/edit/String/index.vue'

import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faTrashAlt)

@Component({
	components: {
		SwitchPortal,
		String,
	},
})
export default class FieldPercentagePortal extends Vue {
	@Prop({ default: null }) model!: number
	@Prop() name!: string
	@Prop() status!: string

	updatableModel: number | null = null

	created() {
		this.updatableModel = this.model
	}

	onInput() {
		this.onUpdate()
	}

	onUpdate() {
		const emitValue = this.updatableModel
		this.$emit('input', this.name, emitValue)
	}
}
